// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPropertyModal__Content {
  padding: 1rem;
}
.AddPropertyModal__Title {
  color: var(--smartflip-blue);
}
.AddPropertyModal__SearchField {
  width: 100%;
}
.AddPropertyModal__Form {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
}
.AddPropertyModal__SearchInput {
  --highlight-color-valid: var(--smartflip-blue, black);
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid lightblue;
  width: 100%;
}
.AddPropertyModal__Button--disabled {
  background-color: gray;
  pointer-events: none;
}
.AddPropertyModal__Button:first-of-type {
  margin-right: 1rem;
}
.AddPropertyModal ::ng-deep .AddPropertyModal__stateField, .AddPropertyModal ::ng-deep .AddPropertyModal__zipField {
  max-width: 9rem;
  background-color: black;
}
.AddPropertyModal .break {
  content: "";
  display: block;
  flex-basis: 100%;
  height: 0;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/home-list/add-property-modal/add-property-modal.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,4BAAA;AADJ;AAIE;EACE,WAAA;AAFJ;AAKE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAHJ;AAME;EACE,qDAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;AAJJ;AAQI;EACE,sBAAA;EACA,oBAAA;AANN;AAQI;EACE,kBAAA;AANN;AAYM;EAEE,eAAA;EACA,uBAAA;AAXR;AAgBE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAdJ","sourcesContent":[".AddPropertyModal {\n  &__Content {\n    padding: 1rem;\n  }\n\n  &__Title {\n    color: var(--smartflip-blue);\n  }\n\n  &__SearchField {\n    width: 100%;\n  }\n\n  &__Form {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    margin-top: 0.5rem;\n  }\n\n  &__SearchInput {\n    --highlight-color-valid: var(--smartflip-blue, black);\n    padding: 0.5rem;\n    border-radius: 6px;\n    border: 1px solid lightblue;\n    width: 100%;\n  }\n\n  &__Button {\n    &--disabled {\n      background-color: gray;\n      pointer-events: none;\n    }\n    &:first-of-type {\n      margin-right: 1rem;\n    }\n  }\n\n  ::ng-deep {\n    .AddPropertyModal {\n      &__stateField,\n      &__zipField {\n        max-width: 9rem;\n        background-color: black;\n      }\n    }\n  }\n\n  .break {\n    content: '';\n    display: block;\n    flex-basis: 100%;\n    height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
